import React from "react";
import { useState } from "react";
import "./Home/styles/Footer.css";
import {
  faBath,
  faBed,
  faRuler,
  faLocationDot,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faLinkedin,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
import { FaWhatsapp, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
  const [email, setEmail] = useState("");
  let [status, setStatus] = useState("Subscribe");
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(email);

    await axios
      .post(`${process.env.REACT_APP_API_URL}/subscribe`, { email })
      .then((response) => {
        console.log("Response Sent");
        setStatus("Subscribed");
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          // Assuming your backend sends 409 Conflict if email already subscribed
          setStatus("Already Subscribed");
        } else {
          setStatus("Try Again");
        }
        console.error("Error:", error);
      });
  };
  const inputStyles =
    "w-full h-[40px] px-3 text-sm text-gray-700 border border-gray-300 rounded-md bg-white/90";
  return (
    <footer className="font-sans text-sm text-white bg-black md:text-base">
      <div className="px-4 py-4 mx-auto max-w-7xl md:py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Newslater*/}
          <div>
            <ul className="">
              <h6 className="mb-3 text-lg font-semibold uppercase whitespace-nowrap">
                Subscribe to Our Newsletter
              </h6>

              <li>
                <p className="pt-2 text-xs text-center bg-black border-t border-gray-800">
                  Enter your email to receive latest updates.
                </p>
              </li>
              <li>
                <form onSubmit={handleSubmit}>
                  {" "}
                  <div className="row">
                    <div className="flex items-center col-2 justify-evenly">
                      <input
                        className={inputStyles}
                        type="email"
                        placeholder="Email"
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <button className="rounded-md p-2  m-3 bg-[#173D73] hover:bg-[#DE241A] text-white">
                        {status}
                      </button>
                    </div>
                    <div className="col-2"></div>
                  </div>
                </form>
              </li>
            </ul>
            <div className="flex justify-center md:justify-normal">
              <ul>
                <li className="flex items-center justify-start social-icons">
                  <a
                    href="https://wa.me/0528284121"
                    className="text-3xl text-white hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>
                  <a
                    href="https://google.com"
                    className="ml-4 text-3xl text-white hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a
                    href="https://google.com"
                    className="ml-4 text-2xl text-white hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fab fa-linkedin"
                      style={{ borderRadius: "3px", padding: "2px" }}
                    ></i>
                  </a>
                  <a
                    href="https://google.com"
                    className="ml-4 text-2xl text-white hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* Services */}
          <div>
            <h6 className="mb-3 text-lg font-semibold uppercase">Explore</h6>
            <ul className="space-y-3">
              {/* <li><a href="/rentRealEstate" className="hover:underline">Rent</a></li>
              <li><a href="/buyRealEstate" className="hover:underline">Buy</a></li> */}
              <li>
                <a
                  href="/residentialRealEstate"
                  className="text-sm hover:underline"
                >
                  Residential
                </a>
              </li>
              <li>
                <a
                  href="/commercialRealEstate"
                  className="text-sm hover:underline"
                >
                  Commercial
                </a>
              </li>
              <li>
                <a href="/holidayHomes" className="text-sm hover:underline">
                  Holiday Homes
                </a>
              </li>
              <li>
                <a
                  href="/upcoming-properties"
                  className="text-sm hover:underline"
                >
                  Off Plan Developments
                </a>
              </li>
            </ul>
          </div>

          {/* Site Info */}
          <div>
            <h6 className="mb-3 text-lg font-semibold uppercase">
              Quick Links
            </h6>
            <ul className="space-y-3">
              <li>
                <a href="/career" className="text-sm hover:underline">
                  Career
                </a>
              </li>
              <li>
                <a href="/blog" className="text-sm hover:underline">
                  News & Blogs
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-sm hover:underline">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="text-sm hover:underline">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h6 className="mb-4 text-lg font-semibold uppercase">
              Get in Touch
            </h6>
            <ul className="space-y-4 text-sm">
              {/*  <li className="flex items-center justify-center md:items-start md:justify-start">
                <svg
                  className="w-5 h-5 mt-1 mr-3"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.69-8.69a2.25 2.25 0 00-3.18 0L1.5 11.47a.75.75 0 101.06 1.06l8.69-8.69z" />
                  <path d="M12 5.432l8.159 8.159v6.198a1.875 1.875 0 01-1.875 1.875H15v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75v4.5H5.625a1.875 1.875 0 01-1.875-1.875v-6.198L12 5.432z" />
                </svg>
                Reef Tower, Cluster O, Floor 6, Office 602-B
              </li>*/}
              <li className="flex items-center justify-center md:justify-start">
                <svg
                  className="w-5 h-5 mr-3"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.93 5.49a3 3 0 01-3.14 0L1.5 8.67z" />
                  <path d="M22.5 6.91V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.16l9.71 5.98a1.5 1.5 0 001.57 0L22.5 6.91z" />
                </svg>
                <a href={"mailto: propertyhub@ucs-mail.com"}>
                  propertyhub@ucs-mail.com
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-start">
                <svg
                  className="w-5 h-5 mr-3"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M1.5 4.5a3 3 0 013-3h1.37c.86 0 1.61.59 1.82 1.42l1.1 4.42a1.88 1.88 0 01-.69 1.96l-1.3.97c-.13.1-.16.25-.13.35a11.28 11.28 0 006.7 6.7c.1.04.25.01.35-.13l.97-1.29a1.88 1.88 0 011.95-.69l4.42 1.1c.83.21 1.42.96 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.55 22.5 1.5 15.45 1.5 6.75V4.5z" />
                </svg>
                <a href="tel:+971528284121"> 971 58 9821460</a>
              </li>
              <li className="flex items-center justify-center md:justify-start">
                <svg
                  className="w-6 h-6 mb-4 mr-2"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.69-8.69a2.25 2.25 0 00-3.18 0L1.5 11.47a.75.75 0 101.06 1.06l8.69-8.69z" />
                  <path d="M12 5.432l8.159 8.159v6.198a1.875 1.875 0 01-1.875 1.875H15v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75v4.5H5.625a1.875 1.875 0 01-1.875-1.875v-6.198L12 5.432z" />
                </svg>
                <a href="https://www.google.com/maps/place/UCS+Prime+Real+Estate+LLC/@25.0740719,55.1402848,17z/data=!4m15!1m8!3m7!1s0x3e5f6d65995030e5:0xfc2fad1b7d51910e!2sUCS+Prime+Real+Estate+LLC!8m2!3d25.0740671!4d55.1428597!10e1!16s%2Fg%2F11xg43xqb5!3m5!1s0x3e5f6d65995030e5:0xfc2fad1b7d51910e!8m2!3d25.0740671!4d55.1428597!16s%2Fg%2F11xg43xqb5?entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D">
                  Reef Tower,Cluster O,
                  <br />
                  Floor 6,Office 602-B
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="py-4 text-xs text-center bg-black border-t border-gray-800">
        © 2025 UCS Prime Real Estate. All rights reserved.
      </div>
      {/* <div className="fixed z-50 flex flex-col items-center space-y-4 top-1/3 right-4">
        <a
          href="https://api.whatsapp.com/send?phone=528284121
&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Varela%202."
          className="flex my-1 mr-2 text-sm text-white duration-200 border bg-[#173d73] rounded enq-bttns1 border-green-50 hover:bg-green-400 hover:text-white sm:my-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
        <a
          href="/contact"
          target="_blank"
          rel="noreferrer"
          className="flex my-1 mr-2 text-sm text-white duration-200 border bg-[#173d73] rounded enq-bttns1 border-green-50 hover:bg-green-400 hover:text-white sm:my-2"
          data-once="footer-enquiry-btn"
        >
          <FontAwesomeIcon icon={faPhone} />
        </a>
      </div>*/}
      <div className="fixed z-50 flex flex-col items-center space-y-4 top-1/3 right-4">
        {/* Phone Call */}
        <a href="tel:+971589821460" className="group">
          <div className="p-3 transition-all duration-300 bg-[#173d73] rounded-full rounded-br-sm shadow-md hover:bg-[#e21f23]">
            <FaPhoneAlt className="text-xl text-white" />
          </div>
        </a>

        {/* WhatsApp */}
        <a
          href="https://api.whatsapp.com/send?phone=589821460&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Varela%202."
          target="_blank"
          rel="noopener noreferrer"
          className="group"
        >
          <div className="p-3 transition-all duration-300 bg-[#173d73] rounded-full rounded-br-sm shadow-md hover:bg-[#e21f23]">
            <FaWhatsapp className="text-xl text-white" />
          </div>
        </a>

        {/* Email */}
        <a href="mailto:propertyhub@ucs-mail.com" className="group">
          <div className="p-3 transition-all duration-300 bg-[#173d73] rounded-full rounded-br-sm shadow-md hover:bg-[#e21f23]">
            <FaEnvelope className="text-xl text-white" />
          </div>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
